<template>
  <Form
    class="flex flex-col gap-y-4 w-full"
    :resolver="loginResolver"
    ref="loginForm"
    v-slot="$form"
    v-focustrap
    @keydown.prevent.enter="$emit('submit')"
  >
    <LabeledField
      label="Email Address"
      :field="$form.email"
    >
      <InputText
        type="email"
        name="email"
        fluid
        data-test="email-input"
      />
    </LabeledField>
    <LabeledField
      label="Password"
      :field="$form.password"
    >
      <Password
        name="password"
        :feedback="false"
        fluid
        data-test="password-input"
      />
    </LabeledField>
    <div class="flex grow justify-end">
      <a
        href="/forgot-password"
        data-test="forgot-password-link"
        >Forgot Password?</a
      >
    </div>
  </Form>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { z } from 'zod';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { useAuthStore } from '@/stores/AuthStore.js';
import LabeledField from '@/components/forms/LabeledField.vue';

const loginForm = ref(null);
const loginResolver = zodResolver(
  z.object({
    email: z.string().email().min(1),
    password: z.string().min(5),
  }),
);

onMounted(() => {
  useAuthStore().loginForm = loginForm.value;
});
</script>
